<p *ngIf="header" class="header">{{ header }}</p>

<div class="selected-list" [class.is-viewing]="!canEdit">
  <ng-container *ngFor="let item of displayedSelectedList$ | async">
    <app-pencil-pill
      [text]="item[valuePropName]"
      [isRemovable]="canEdit"
      (remove)="removeSelectedItem(item)"
      class="item-pill"
      [appTooltip]="item[valuePropName]"
      appTooltipPlacement="bottom-center"
      [appTooltipOffsetY]="5"
    ></app-pencil-pill>
  </ng-container>

  <app-pencil-pill
    *ngIf="moreTagsToShow$ | async"
    [text]="'+' + (selectedList.length - maxShownTags)"
    [appTooltip]="
      canExpandHiddenTags
        ? ('Click to view all tags' | translate)
        : ((hiddenSelectedList$ | async) || [] | joinProperties: valuePropName:'\n')
    "
    [appTooltipPlacement]="'bottom-center'"
    [appTooltipArrow]="'top'"
    [appTooltipCreateNewLine]="true"
    [isRemovable]="false"
    class="item-pill"
  ></app-pencil-pill>

  <app-pencil-button
    *ngIf="canEdit"
    [ngClass]="{
      'pencil-button': true,
      small: (isSelectedListEmpty$ | async),
      white: (isSelectedListEmpty$ | async),
      'placeholder-btn': (isSelectedListEmpty$ | async),
      'add-btn': (isSelectedListEmpty$ | async) === false
    }"
    (clickEvent)="openDialog()"
    [icon]="'add'"
    [iconConfig]="{ type: IconTypes.matIcon }"
    [label]="selectedList.length ? '' : placeholder"
  >
  </app-pencil-button>
</div>
